import { Control } from 'react-hook-form';

import { Box } from '@mui/material';

import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import {
  CodeExternField,
  CodeField,
  CompensationTypeIdField,
  DescriptionField,
  IsExternalField,
  TransportationModeField
} from './FormFields';
import { useTranslation } from 'react-i18next';

export const BaseArrangementSection = ({
  control
}: {
  control: Control<any>;
}) => {
  const { t } = useTranslation('common');
  return (
    <MultiStepForm.Section title={t('basis')}>
      <Box display="flex" gap={2.5}>
        <CodeField control={control} />
      </Box>
      <Box display="flex" gap={2.5}>
        <CodeExternField control={control} />
      </Box>
      <Box display="flex" gap={2.5}>
        <DescriptionField control={control} />
      </Box>
      <Box>
        <CompensationTypeIdField control={control} />
      </Box>
      <Box>
        <TransportationModeField control={control} />
      </Box>
      <Box display="flex" gap={2.5}>
        <IsExternalField control={control} />
      </Box>
    </MultiStepForm.Section>
  );
};
